import { Input, Typography } from 'antd';

export const isMissingReason = (didNotWork: boolean, reason: string) =>
    didNotWork && reason.trim().length === 0;

export const DidNotWorkReason = ({
    value,
    onChange,
}: {
    value: string;
    onChange: (value: string) => void;
}) => (
    <>
        <Typography.Text strong>Reason</Typography.Text>
        <Input.TextArea
            rows={3}
            value={value}
            placeholder="Why did the nurse not work this shift?"
            onChange={(e) => onChange(e.target.value)}
        />
    </>
);
